const $ = jQuery.noConflict();

const buttons = $(".js-read-more");

const triggerContent = (e) => {
    const _this = $(e.target);
    const content = _this.next();
    const defaultText = _this.attr("data-default-text");
    const activeText = _this.attr("data-active-text");
    const textElement = _this.find(".js-read-more-text");
    if (_this.hasClass("open")) {
        _this.removeClass("open");
        content.slideUp(300);
        if (textElement && defaultText) {
            textElement.text(defaultText);
        }
    } else {
        _this.addClass("open");
        content.slideDown(300);
        if (textElement && activeText) {
            textElement.text(activeText);
        }
    }
};

buttons.on("click", triggerContent);
